export default __webpack_public_path__ + "static/media/Background (1).cac9a910.png";